import { render, staticRenderFns } from "./HoldingSection.vue?vue&type=template&id=193dbffb&scoped=true"
import script from "./HoldingSection.vue?vue&type=script&lang=js"
export * from "./HoldingSection.vue?vue&type=script&lang=js"
import style0 from "./HoldingSection.vue?vue&type=style&index=0&id=193dbffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193dbffb",
  null
  
)

export default component.exports